import RealtyCard from "@/app/core/layouts/main-components/realty/RealtyCard";
import React, { useState, useEffect } from "react";
import { PropertiesController } from "@/app/core/base/controllers/PropertiesController";

export default function PopularHouse({ location }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    console.log("Executing callback", location);
    if (location?.lat && location?.lng) {
      executeQuery();
    }
  }, [location]);

  async function executeQuery() {
    const rangeInKm = 50.0;
    const userLocation = {
      lat: location.lat,
      lng: location.lng,
    };
    const realEstateTypes = [
      "7H1eSsCdwvXFsbzsolCu", // Casa de condomínio
      "J7L6bgy6TGqPF3ukXtRa", // Casa de vila
      "KyVcEe5hzeDKfSLEQxnw", // Casa
    ];

    let properties = await PropertiesController.QueryPropertiesInRange(
      userLocation,
      rangeInKm,
      realEstateTypes
    );
    if (properties) {
      setData(properties);
    }
  }

  return (
    <div className="row mt-5">
      <div className="col-md-12 text-center">
        <h2
          className="text-muted font-w700 border-botom"
          style={{ lineBreak: "auto" }}
        >
          Casas mais populares perto de você
        </h2>
        <hr
          className="border-4x border-warning"
          style={{ color: "#F36161", width: 124 }}
        />
      </div>

      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 row">
          {data &&
            data.map((item) => (
              <div key={item.id} className="col-md-4 pl-1 pr-3">
                <RealtyCard data={item} iconDescription={false} />
              </div>
            ))}
        </div>
        <div className="col-1"></div>
      </div>
    </div>
  );
}
